import { Building2 } from "lucide-react";
import { SectionHeader } from "./SectionHeader";
import { ALUMNI_COMPANIES } from "../lib/constants";

export const Alumni = () => {
  return (
    <section className="py-20 md:py-28 bg-[#F8FAF9] relative overflow-hidden" data-testid="alumni-section">
      <div className="absolute inset-0 tassei-dot-bg opacity-40" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-10">
        <SectionHeader
          eyebrow="Where Our Alumni Work"
          title="From TASSEI to top employers."
          desc="Our learners are building careers across India's most respected companies in IT, services, design, finance and consulting."
        />

        <div
          className="mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3"
          data-testid="alumni-grid"
        >
          {ALUMNI_COMPANIES.map((c, i) => (
            <div
              key={c}
              data-testid={`alumni-${i}`}
              className="group bg-white border border-slate-200 rounded-xl px-4 py-5 flex items-center gap-3 hover:border-[#00B37E] hover:-translate-y-0.5 hover:shadow-md transition-all"
            >
              <div className="w-9 h-9 rounded-lg bg-[#00B37E]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[#00B37E]/20 transition-colors">
                <Building2 className="w-4 h-4 text-[#00B37E]" />
              </div>
              <div className="text-sm font-bold text-[#0A192F] leading-tight">{c}</div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-xs text-[#64748B] text-center">
          * Indicative list of companies hiring talent across India. Specific placements depend on role, location and performance.
        </p>
      </div>
    </section>
  );
};

export default Alumni;
